import jwt from "jwt-decode";
import consts from "../../main/consts";
import { setReloadPopup, showMessage } from "../app/appActions";

export const types = {
  AUTH_LOGIN: "AUTH_LOGIN",
  AUTH_LOAD_USER_INFO: "AUTH_LOAD_USER_INFO",
  AUTH_GET_STORES: "AUTH_GET_STORES",
  AUTH_CHANGE_STORE: "AUTH_CHANGE_STORE",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  AUTH_CLEAR_STORE: "CLEAR_STORE",
  // SET_DEVOLUTION: 'SET_DEVOLUTION',
};

export const doLogin = async () => async (dispatch) => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");

  if (token) {
    const data = jwt(token);

    if (data.allStores) {
      dispatch(getLojas(token));
    } else {
      const userInfo = {
        isLoggingIn: true,
        token: token,
        lojas: data.stores || [],
        loja: (data.stores && data.stores[0]) || "",
        role: data.role,
        roles: data.roles,
        isAdmin: data.isAdmin,
      };

      dispatch({
        type: types.AUTH_LOGIN,
        payload: userInfo,
      });

      window.location.href = `/dashboard`;
    }
  }
};

export const getLojas = (token) => (dispatch) => {
  const jwtData = jwt(token);
  const timestamp = new Date().getTime();
  const storesEndpoint = `${consts.STORES_ENDPOINT}?t=${timestamp}`;

  fetch(storesEndpoint, {
    method: "GET",
    cache: "no-store",
  })
    .then((res) => {
      if (res.ok) return res.json();

      return { stores: consts.DEBUG_ENABLED ? [consts.DEBUG_LOJA] : [] };
    })
    .then(({ data }) => {
      const lojas = data.stores || [];
      if (consts.DEBUG_ENABLED) lojas.push(consts.DEBUG_LOJA);

      const userInfo = {
        isLoggingIn: true,
        token: token,
        lojas,
        loja: (lojas[0] && lojas[0].CO_LOJA) || "",
        role: jwtData.role,
        roles: jwtData.roles,
        isAdmin: jwtData.isAdmin,
      };

      dispatch({
        type: types.AUTH_LOGIN,
        payload: userInfo,
      });

      window.location.href = `/dashboard`;
    })
    .catch(() => {
      localStorage.clear();
      dispatch(showMessage("Não foi possível obter as lojas do usuário. Tente novamente mais tarde.", "error"));

      setTimeout(() => {
        window.location.href = `/unauthorized`;
      }, 3000);
    });
};

export const getLatestVersion = () => (dispatch) => {
  const timestamp = new Date().getTime();
  fetch(`${window.location.origin}${consts.CONTEXT}/version.cfg?t=${timestamp}`, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  })
    .then((res) => {
      if (res.ok) return res.text();

      return null;
    })
    .then((version) => {
      const serverVersion = String(version).trim();
      const appVersion = consts.APP_VERSION;

      if (serverVersion && serverVersion !== appVersion) {
        dispatch(setReloadPopup(true, serverVersion));
      }
    })
    .catch((error) => {
      console.warn('Failed to check app version:', error);
    });
};

export const setLoja = (loja) => (dispatch) => {
  dispatch({ type: types.AUTH_CHANGE_STORE, payload: loja });
  window.location.href = `${consts.CONTEXT}/dashboard`;
};

export const doLogout = async () => async (dispatch) => {
  dispatch({ type: types.AUTH_LOGOUT });
};
